export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/utils/expandToHashMap.js
// module id = 322
// module chunks = 75